// extracted by mini-css-extract-plugin
module.exports = {"details":"CategoryDetails_details__l2bLC"};